export default __webpack_public_path__ + "static/media/checkbox.67f8460b.png";